module.exports = __webpack_public_path__ + "img/kvickly.4411f12f.png";